const en = {
  // Home Screen
  roaming_screen_title: 'Roaming',
  roaming_settings_title: 'Roaming Settings',
  roaming_settings_description:
    'Make sure to activate Roaming service in your device\'s Roaming Settings and Network Settings',
  roaming_where_to: 'What\'s your destination?',
  roaming_where_to_description:
    'Purchase a Roaming bundle valid for your destination',
  roaming_select_destination: 'Choose your destination',
  romaing_select_prepaid: "Prepaid/Hybrid",
  roaming_select_postpaid: "Postpaid / Unlimited",
  roaming_explore_card_title:
    'In %1$s you can use Roaming Travel Pack bundle during your stay',
  roaming_buy_plan: 'Purchase',
  roaming_bundles_title: 'Bundles',
  roaming_bundles_button_title: 'Roaming Bundles',
  roaming_more_info: 'More Info',
  roaming_close: 'Close',

  // Error
  roaming_get_recommandation_error: "Click here to refetch Recommendation",

  // Search Screen
  roaming_search_country: 'Select your destination',
  roaming_search_country: 'Search for a country',
  roaming_search_description:
    'Red Roaming allows you to use your plan in roaming just like at home',

  // Country Roaming Screen
  roaming_country_to: 'Traveling to %1$s',
  roaming_country_to_description:
    'Take a look to our travel guide',
  roaming_calculator_offerCard: 'Welcome to %1$s.\n%1$s\n%1$s',
  roaming_calculator_yes_bundle: 'In %1$s you can use Roaming Travel Pack bundle. Check below',
  roaming_calculator_no_bundle: 'There are no roaming bundles applicable in %1$s. Find below the standard rates ',
  roaming_learn_more: 'Learn More',
  roaming_country_calculator_title: 'Standard Rates',
  roaming_country_calculator_description: 'Albania to:',
  roaming_country_calculator_service_provider:
    'Our recommended service provider is: %1$s',

  // Country Details Screen
  roaming_country_details_title: 'Useful information',
  roaming_country_details_currency: 'Currency',
  roaming_country_details_capital: 'Capital',
  roaming_country_details_prefix: 'Prefix',
  roaming_country_details_emergencySectionTitle: 'Emergency Numbers',
  roaming_country_details_free_to_call: 'Free to call',

  // Embassies

  roaming_embassies_title: 'Embassie',
  roaming_embassies_consulates_title: 'Consulates',
  roaming_embassies_copy: 'Copy',
  roaming_embassies_copied: 'Copied',
  roaming_embassies_call: 'Call',
  roaming_embassies_website: 'Website',
  roaming_embassies_phone_number: 'Phone Number',
  roaming_embassies_working_hours: 'Working Hours',


  roaming_bundles_default_error: 'Something went wrong! Try Again',
  roaming_country_offers_subtitle: 'Take a look to the available Roaming bundles.'
}

export default en
